import {Component, Inject, ChangeDetectionStrategy} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {StorageLocation} from "@knust/api-interfaces";
import {FormBuilder, FormControl, Validators} from "@angular/forms";

@Component({
    selector: 'knust-storage-location-dialog',
    templateUrl: './storage-location-dialog.component.html',
    styleUrls: ['./storage-location-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StorageLocationDialogComponent {
  storageLocationForm = this.fb.group({
    label: ['', Validators.required],
    notificationMail: [null, Validators.email],
    orderCCMail: [null, Validators.email],
    address: this.fb.group({
      street: ['', Validators.required],
      zip: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      addressSupplement: [''],
      latitude: new FormControl<number|null>(null),
      longitude: new FormControl<number|null>(null),
    }),
    note: ['']
  });

  constructor(
    public dialogRef: MatDialogRef<StorageLocationDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data?: StorageLocation,
  ) {
    if (data) {
      this.storageLocationForm.patchValue(data);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  saveOnEnter(event: Event) {
    const target = event.target as HTMLElement | null;

    // In der Notiz soll Enter einen Zeilenumbruch erzeugen, in der Länderauswahl eine Option wählen
    if (target?.tagName === 'TEXTAREA' || target?.closest('mat-select')) {
      return;
    }

    event.preventDefault();

    // Nur speichern, wenn auch der Speichern-Button aktiv wäre
    if (this.storageLocationForm.valid && !this.storageLocationForm.pristine) {
      this.save();
    }
  }

  save() {
    if (this.storageLocationForm.valid) {
      this.dialogRef.close({
        id: this.data?.id ?? null,
        ...this.storageLocationForm.value,
        address: {
          id: this.data?.address?.id ?? null,
          ...this.storageLocationForm.get('address')?.value,
        },
      });
    }
  }
}
